import { Box, Button, Chip, Container, Grid, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ContentCutRoundedIcon from "@mui/icons-material/ContentCutRounded";
import LocalFireDepartmentRoundedIcon from "@mui/icons-material/LocalFireDepartmentRounded";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";

const beefDetails = [
  {
    icon: <RestaurantRoundedIcon />,
    image: "/grill-3.jpg",
    imagePosition: "35% center",
    title: "ARGENTINISCHES ENTRECÔTE",
    desc: "150 g saftiges Rib-Eye bilden das Herzstück unseres Beef Philly.",
  },
  {
    icon: <ContentCutRoundedIcon />,
    image: "/grill-3.jpg",
    imagePosition: "55% center",
    title: "DÜNN GESCHNITTENES RIB-EYE",
    desc: "Unser Entrecôte wird frisch und dünn geschnitten – als Steak Strips oder Chopped Beef.",
  },
  {
    icon: <LocalFireDepartmentRoundedIcon />,
    image: "/grill-3.jpg",
    imagePosition: "75% center",
    title: "ENTRECÔTE VON DER GRILLPLATTE",
    desc: "Erst bei deiner Bestellung kommt das Rib-Eye auf die heiße Platte – für saftiges Beef mit kräftigem Geschmack.",
  },
];

export default function WhyChooseUs() {
  return (
    <Box
      id="angebot"
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 10, md: 15 },
        color: "#fff",
        background:
          "radial-gradient(circle at 82% 18%, rgba(122,31,27,0.22), transparent 34%), #0b0a09",
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: "absolute",
          width: 360,
          height: 360,
          border: "1px solid rgba(255,255,255,0.04)",
          borderRadius: "50%",
          left: -180,
          bottom: -190,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Grid container spacing={{ xs: 6, md: 9 }} alignItems="center">
          <Grid item xs={12}>
            <Chip
              label="UNSER BEEF"
              sx={{
                mb: 3,
                color: "#fff",
                bgcolor: "primary.main",
                fontWeight: 800,
                letterSpacing: "0.14em",
              }}
            />

            <Typography
              component="h2"
              sx={{
                maxWidth: 760,
                fontSize: { xs: "2.45rem", sm: "3.5rem", md: "4.35rem" },
                lineHeight: 0.98,
                letterSpacing: "-0.045em",
                fontWeight: 900,
                textTransform: "uppercase",
              }}
            >
              Argentinisches Entrecôte.
              <Box component="span" sx={{ display: "block", color: "primary.main", mt: 1 }}>
                Der Star unseres Philly.
              </Box>
            </Typography>

            <Typography
              sx={{
                mt: 4,
                maxWidth: 720,
                color: "rgba(255,255,255,0.74)",
                fontSize: { xs: "1.05rem", md: "1.16rem" },
                lineHeight: 1.8,
              }}
            >
              Bei Prince of Philly steht das Fleisch im Mittelpunkt. Für unser Beef Philly
              verwenden wir argentinisches Entrecôte (Rib-Eye) – dünn geschnitten und frisch
              auf der heißen Grillplatte zubereitet. Saftig, kräftig im Geschmack und genau das,
              was ein richtig gutes Philly braucht.
            </Typography>
          </Grid>

        </Grid>

        <Box
          sx={{
            mt: { xs: 6, md: 8 },
            display: "grid",
            gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(3, minmax(0, 1fr))" },
            gap: 2.5,
            alignItems: "stretch",
          }}
        >
          {beefDetails.map((item, index) => (
              <Box
                key={item.title}
                sx={{
                  width: "100%",
                  boxSizing: "border-box",
                  height: "100%",
                  minHeight: { xs: 360, md: 390 },
                  p: { xs: 3, md: 3.5 },
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                  bgcolor: "rgba(255,255,255,0.035)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  transition: "transform .25s ease, background-color .25s ease",
                  "&:hover": { transform: "translateY(-5px)", bgcolor: "rgba(122,31,27,0.11)" },
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt=""
                  loading="lazy"
                  sx={{
                    width: 128,
                    height: 128,
                    mb: 3,
                    borderRadius: "50%",
                    objectFit: "cover",
                    objectPosition: item.imagePosition,
                    border: "2px solid",
                    borderColor: "primary.main",
                    boxShadow: "0 16px 34px rgba(0,0,0,0.36)",
                  }}
                />
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, color: "primary.main", mb: 2 }}>
                  {item.icon}
                  <Typography sx={{ color: "rgba(255,255,255,0.35)", fontWeight: 800 }}>
                    0{index + 1}
                  </Typography>
                </Box>
                <Typography sx={{ fontWeight: 900, letterSpacing: "0.04em", mb: 1.2 }}>
                  {item.title}
                </Typography>
                <Typography sx={{ color: "rgba(255,255,255,0.68)", lineHeight: 1.7 }}>
                  {item.desc}
                </Typography>
              </Box>
          ))}
        </Box>

        <Box
          sx={{
            mt: { xs: 7, md: 10 },
            pt: { xs: 5, md: 6 },
            borderTop: "1px solid rgba(255,255,255,0.11)",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              maxWidth: 940,
              mx: "auto",
              fontSize: { xs: "1.65rem", md: "2.65rem" },
              lineHeight: 1.12,
              fontWeight: 900,
              letterSpacing: "-0.025em",
              textTransform: "uppercase",
            }}
          >
            Komm nicht nur für ein Philly. Komm für das Entrecôte.
          </Typography>

          <Button
            component="a"
            href="/Prince_of_Philly_Speisekarte.pdf"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              mt: 4,
              px: { xs: 3.5, md: 5 },
              py: 1.7,
              borderRadius: 0,
              fontWeight: 900,
              letterSpacing: "0.05em",
              boxShadow: "0 14px 36px rgba(122,31,27,0.28)",
            }}
          >
            UNSER BEEF PHILLY ENTDECKEN
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
